import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from './assets/SVGicons/logoandmenu-quill-black.svg';
import accountIcon from './assets/SVGicons/account-gray.svg';

const TopNav = ({ user }) => {
    const location = useLocation();
    const [hoveredNav, setHoveredNav] = useState(null);
    const [opacity, setOpacity] = useState(1);
    const [prevPath, setPrevPath] = useState(location.pathname);

    const navPaths = ['/', '/learning'];
    const isNavPath = navPaths.includes(location.pathname);
    const wasNavPath = navPaths.includes(prevPath);

    useEffect(() => {
        if (!isNavPath) {
            setOpacity(0);
        } else if (!wasNavPath && isNavPath) {
            setOpacity(0);
            setTimeout(() => setOpacity(1), 50);
        } else {
            setOpacity(1);
        }
        setPrevPath(location.pathname);
    }, [location.pathname]);

    const btnStyle = (path) => ({
        borderRadius: "8px",
        border: hoveredNav === path ? "1px solid #ccc" : "1px solid transparent",
        padding: "6px 14px",
        cursor: "pointer",
        backgroundColor: "#fff",
        fontSize: "14px",
        display: "block",
        transition: "border-color 0.15s ease",
        color: "inherit"
    });

    const navItem = (path, label) => (
        <div
            style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}
            onMouseEnter={() => setHoveredNav(path)}
            onMouseLeave={() => setHoveredNav(null)}
        >
            <button style={btnStyle(path)}>{label}</button>
            <div style={{
                width: "60%",
                height: "2px",
                backgroundColor: "#999",
                borderRadius: "2px",
                opacity: location.pathname === path ? opacity : 0,
                transition: !isNavPath
                    ? "opacity 0.5s ease"
                    : (!wasNavPath && isNavPath)
                        ? "opacity 2s ease"
                        : "opacity 0.3s ease"
            }} />
        </div>
    );

    return (
        <div style={{
            padding: "10px",
            borderBottom: "1px solid #ccc",
            marginBottom: "20px",
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
            position: "relative"
        }}>
            {user ? (
                <Link
                    to="/app"
                    style={{ textDecoration: "none", color: "inherit", position: "absolute", top: "10px", left: "10px" }}
                >
                    <img
                        src={logo}
                        alt="OneWriter"
                        style={{ width: "36px", height: "36px", display: "block" }}
                    />
                </Link>
            ) : (
                <div style={{ position: "absolute", top: "10px", left: "10px" }}>
                    <img
                        src={logo}
                        alt="OneWriter"
                        style={{ width: "36px", height: "36px", display: "block" }}
                    />
                </div>
            )}

            <div style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                flex: 1
            }}>
                <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>{navItem('/', 'Welcome')}</Link>
                <Link to="/learning" style={{ textDecoration: "none", color: "inherit" }}>{navItem('/learning', 'Learn')}</Link>
            </div>

            {user && (
                <Link
                    to="/account"
                    style={{ textDecoration: "none", color: "inherit", position: "absolute", top: "14px", right: "10px" }}
                >
                    <img
                        src={accountIcon}
                        alt="Account"
                        style={{ width: "24px", height: "24px", display: "block" }}
                    />
                </Link>
            )}
        </div>
    );
};

export default TopNav;